import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../_metronic/_partials/controls";
import BootstrapTable from "react-bootstrap-table-next";
import {
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
  headerSortingClasses,
} from "../../_metronic/_helpers";
import { useSubheader } from "../../_metronic/layout";
import { Link, useHistory } from "react-router-dom";
import { baseURLV1, baseURL } from "../service/API.js";
import moment from "moment";
import Swal from "sweetalert2";
import axios from "axios";
import paginationFactory from "react-bootstrap-table2-paginator";
import Pagination2 from "@material-ui/lab/Pagination";
import { useSelector } from "react-redux";


export const Weeklypass = () => {
  const suhbeader = useSubheader();
  const allData = [];
  const [templateData, setTemplateData] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalSize, setTotalSize] = useState(100);
  const [is_loading, setIs_Loading] = useState(false);
  const [listError, setlistError] = useState(false);
  suhbeader.setTitle("Weekly Checkin Management");
  const { authToken, accessTokenPrivilege } = useSelector((state) => state.auth);
  const [listMasterModel, setListMasterModel] = useState([]);
  const history = useHistory();
  useEffect(() => {
    localStorage.removeItem('edit')
    getListMasterModel(page, limit);
  }, []);

  const getListMasterModel = async (pageData, limitData) => {
    let limitPage = localStorage.getItem('limitPage') ? JSON.parse(localStorage.getItem('limitPage')) : { 'Weeklypass': limit }
    if (!limitPage.Weeklypass) {
      localStorage.setItem('limitPage', JSON.stringify({ 'Weeklypass': limit }))
    }
    if (!limitPage) {
      limitData = limit
    } else {
      if (limitPage.Weeklypass) {
        limitData = limitPage.Weeklypass
        setLimit(limitData)
      } else {
        limitData = limit
      }
    }
    let checkPage = localStorage.getItem('checkPage') ? JSON.parse(localStorage.getItem('checkPage')) : { 'Weeklypass': page }
    if (!checkPage.Weeklypass) {
      localStorage.setItem('checkPage', JSON.stringify({ 'Weeklypass': page }))
    }
    console.log(checkPage)
    if (!checkPage) {
      pageData = page
    } else {
      console.log(checkPage)
      if (checkPage.Weeklypass) {
        console.log(checkPage)
        pageData = checkPage.Weeklypass
        setPage(pageData)
      } else {
        pageData = page
      }
    }
    setIs_Loading(true);
    const apiUrls = `${baseURLV1}/weeklyPass?page=${pageData}&limit=${limitData}`; // รอแก้
    axios({
      method: "get",
      url: apiUrls,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then((res) => {
        res.data.data.map(item => {
          item.popupstart = ISOString(moment(item.popupstart).add(7, 'hours'))
          item.popupend = ISOString(moment(item.popupend).add(7, 'hours'))
          if (item.popupstart > item.popupend) {
            item.popupstart = 'please change start time'
            item.popupend = 'please change end time'
          }
          console.log(item.popupstart, item.popupend, item.popupend > item.popupstart)
        })
        setListMasterModel(res.data.data);
        setIs_Loading(false);
        setlistError(false);

        var totalpage = Math.ceil(res.data.total / res.data.limit);
        setTotalPage(totalpage);
        setTotalSize(res.data.total);
        setLimit(res.data.limit);
        setTemplateData(allData);
      })
      .catch((err) => {
        if (err.response) {
          setIs_Loading(false);
          setlistError(true);
        }
      });
  };

  const convertDate = ( date, formatDate) => {
    const dates = new Date(date)
    const result = dates.toLocaleDateString(formatDate, {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    })

    return result
  }

  const ISOString = (data) => {
    if (!data) {
      return '-'
    }
    let temp = new Date(data)
    console.log(temp.toISOString())
    console.log(`${temp.toISOString().toString().substring(0, 10)} ${temp.toISOString().toString().substring(11, 16)}`)
    return `${temp.toISOString().toString().substring(0, 10)} ${temp.toISOString().toString().substring(11, 16)}`
    // console.log(Date(data).toISOString())
  };
  const columns = [

    /*{
      dataField: "id",
      text: "News Id",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },*/
    {
      dataField: "title_th",
      text: "สัปดาห์ (TH)",
      //sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
            <div style={{width:'100px'}}>
                <p>{row.title_th}</p>
            </div>
        );
    },
    },
    {
      dataField: "title_en",
      text: "สัปดาห์ (EN)",
      //sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
            <div style={{width:'100px'}}>
                <p>{row.title_en}</p>
            </div>
        );
    },
    },
    {
      dataField: "description_th",
      text: "เดือน (TH) ",
     // sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
            <div style={{width:'100px'}}>
                <p>{row.description_th}</p>
            </div>
        );
    },
    },
    {
      dataField: "description_en",
      text: "เดือน (EN)",
      //sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
            <div style={{width:'100px'}}>
                <p>{row.description_en}</p>
            </div>
        );
    },
    },
    {
      text: "รูปภาพไอคอน (TH) ",
      dataField: "image",
      formatter: (img, row, rowIndex) => {
        return (
          <td style={{textAlign:"center", border:"none"}}>
            <div style={{width:'130px'}}>
            </div>
            <img
              style={{
                textAlign:"center",
                width: "50px",
              }}
              src={row.image_th}
            />
          </td>
        );
      },
    },
    {
      text: "รูปภาพไอคอน (EN)",
      dataField: "image",
      formatter: (img, row, rowIndex) => {
        return (
          <td style={{textAlign:"center", border:"none"}}>
            <div style={{width:'130px'}}>
            </div>
            <img
              style={{
                textAlign:"center",
                width: "50px",
              }}
              src={row.image_en}
            />
          </td>
        );
      },
    },
    {
      dataField: "start_date",
      text: "เวลาเริ่มต้น",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
            <div style={{width:'130px'}}>
                <p>{row.start_date ? convertDate(row.start_date, 'th-TH') : '-'}</p>
            </div>
        );
    },
    },
    {
      dataField: "end_date",
      text: "เวลาสิ้นสุด",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
            <div style={{width:'130px'}}>
              <p>{row.end_date ? convertDate(row.end_date, 'th-TH') : '-'}</p>
            </div>
        );
    },
    },
    {
      dataField: "point",
      text: "คะแนนที่ได้รับ",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
            <div style={{width:'130px'}}>
                <p>{row.point}</p>
            </div>
        );
    },
    },
    {
      dataField: "order_item",
      text: "ลำดับการแสดง",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
            <div style={{width:'130px'}}>
                <p>{row.order_item}</p>
            </div>
        );
    },
    },

    {
      text: "Action",
      dataField: "id",
      formatter: (id, row, rowIndex) => {
        return (
          <div style={{ width: '150px' }}>
            <button
              type="button"
              className="btn btn-primary mr-2"
              onClick={() => editItem({ id, row, rowIndex })}
            >
              Edit
            </button>

            <button
              type="button"
              className="btn btn-primary"
              onClick={() => deleteItem({ row, rowIndex })}
            >
              Delete
            </button>

          </div>
        );
      },
    },
    /*{
      text: "Image Management",
      dataField: "id",
      formatter: (id, row, rowIndex) => {
        return (
          <div>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => ImageManagement({ row, rowIndex })}
            >
              Image
            </button>

          </div>
        );
      },
    },*/
  ];

  const editItem = (data) => {
    history.push("/EditWeeklypass", data);
  };

  const deleteItem = (data) => {
    Swal.fire({
      title: "",
      text: "คุณต้องการที่จะลบรายการเช็คอินออกใช่หรือไม่ ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "ลบ",
      cancelButtonText: "ยกเลิก",
    }).then((result) => {
      if (result.value) {
        axios
          .delete(`${baseURLV1}/weeklyPass/${data.row.id}`)
          .then((res) => {
            Swal.fire("", "คุณทำการลบรายการเช็คอินเรียบร้อยแล้ว", "success");
            getListMasterModel(page, limit);
          })
          .catch((err) => {
            Swal.fire(
              "",
              "คุณทำการลบรายการเช็คอินไม่สำเร็จ",
              "error"
            );
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelled", "Your model is safe :)", "error");
      }
    });
  };
  const [search, setSearch] = useState();
  const handleSearch = () => {
    setPage(1);
    getListMasterModel(1, limit, search);
  };

  const handlePageChange = (event, value) => {
    localStorage.setItem('checkPage', JSON.stringify({ 'Weeklypass': value }))
    setPage(value);
    getListMasterModel(value, limit);
  };

  const handlePageSizeChange = (event) => {
    localStorage.setItem('limitPage', JSON.stringify({ 'Weeklypass': event.target.value }))
    localStorage.setItem('checkPage', JSON.stringify({ 'Weeklypass': 1 }))
    setPage(1)
    setLimit(event.target.value);
    getListMasterModel(1, event.target.value);
  };

  return (
    <Card>
      <CardHeader title="Weekly Checkin Management">
        <CardHeaderToolbar>
          <Link to="/CreateWeeklypass">
            <button type="button" className="btn btn-primary">
              + Create
            </button>
          </Link>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>


        {/* /Search Btn/ */}

        {/* <div className="row form-inline mb-2">
          <div className="col-lg-4 col-md-4 col-sm-4">
            <div className="form-group">
              <input
                type="text"
                className="form-control"
                placeholder="Text Search"
                style={{ width: "100%" }}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
          </div>
          <div className="col-lg-2 col-md-2 col-sm-2">
            <div className="form-group">
              <button
                type="button"
                id="button"
                className="btn btn-primary"
                style={{ width: "100%" }}
                onClick={() => handleSearch()}
              >
                Search
              </button>
            </div>
          </div>
        </div> */}


        <BootstrapTable
          keyField="id"
          data={listMasterModel}
          columns={columns}
          wrapperClasses="table-responsive table-cm"
          bordered={false}
          classes="header-table table table-head-custom table-vertical-center overflow-hidden table-fixed"
          bootstrap4
        />
        <div className=" col-lg-12">
          <div className="row">
            <div className="col-lg-6 d-flex align-items-center">
              <div className="mt-3">
                {"Items per Page: "}
                <select onChange={handlePageSizeChange} value={limit}>
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select>
              </div>
              <span class="mt-3 ml-5">Result : {totalSize} records</span>
            </div>
            <div className="col-lg-6">
              <Pagination2
                className="mt-3 "
                count={totalPage}
                page={page}
                siblingCount={1}
                boundaryCount={1}
                variant="outlined"
                shape="rounded"
                onChange={handlePageChange}
              />
            </div>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};
